import {
  SET_ENTITY,
  RESET_LIST_DT_STATE
} from "@/store/mutation-types";

const module = "DT";

const initialState = () => {
  return {
    dataDT: {},
  }
}

export default {
  namespaced: true,
  state: initialState(),

  // getters: {
  //   isListdataDTLoading(state) {
  //     return (
  //       !state.list.length 
  //     );
  //   },
  // },

  mutations: {
    [RESET_LIST_DT_STATE](state) {
      Object.assign(state, initialState());
    }
  },

  actions: {

    async fetchDTMain({ commit }, nd) {
      const params = {
        nd: nd
      }
      const item = await this.$api.dcl.getDT(params);
      commit(
        SET_ENTITY,
        {
          module,
          entity: "dataDT",
          value: item,
        },
        { root: true }
      );
    },
  },
};